module.exports = __webpack_public_path__ + "img/home-delivery_medium@2x.7a04329c.webp";